// extracted by mini-css-extract-plugin
export default {"wrap":"k_PHV","card-image":"hokT3","card-image-wrapper":"qmaQf"};